// extracted by mini-css-extract-plugin
export default {"container":"Title_container__dLaic","title":"Title_title__lR7Af","icon":"Title_icon__XZ2cJ"};